// extracted by mini-css-extract-plugin
export default {"root":"styles_root__hiMRj","tags":"styles_tags__BQswu"};